/**
 * Gets a random element from `array`.
 *
 * @category Array
 * @param {Array} a The array to sample.
 * @param random Returns a number from 0 to 1, e.g. from `useRandom`
 * @returns {*} Returns the random element.
 * @example
 *
 * sample([1, 2, 3, 4])
 * // => 2
 */
export default function sampleArray<T>(
    a: T[],
    random: () => number = Math.random,
): T | undefined {
    return a.length ? a[Math.floor(random() * a.length)] : undefined;
}
